import React, { memo, useState } from "react";
import stylesPc from "./DirectoryIndex.module.css";
import stylesSp from "./DirectoryIndex_SP.module.css";
import FolderIcon from "@material-ui/icons/Folder";
import PuiTypography from "../../../components/elements/PuiTypography";
import { MoreVert } from "@material-ui/icons";
import { Folder, Footage } from "../../models/Timeline";
import VideoFile from "../../../assets/icon/VideoFile";
import { IsDevice } from "../../../components/function/useDeviceFlag";

interface DirectoryListProps {
    directoryList: Folder[];
    footageList: Footage[];
    clickFolder: (id: number, name: string) => void;
    handleEditFolder?: (id: number, name: string) => void;
    handleDeleteFolder?: (id: number, hasDir: boolean) => void;
    handleClickFootage?: (id: number, status: string) => void;
    handleEditFootage?: (id: number, name: string) => void;
    handleDeleteFootage?: (id: number) => void;
    directoryRef: React.MutableRefObject<HTMLTableElement | null>;
}

function DirectoryList({
    directoryList,
    footageList,
    clickFolder,
    handleEditFolder,
    handleDeleteFolder,
    handleClickFootage,
    handleEditFootage,
    handleDeleteFootage,
    directoryRef,
}: DirectoryListProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    // 編集modal表示用
    const [directoryIndex, setDerectoryIndex] = useState<number>(-1);
    const [footageIndex, setFootageIndex] = useState<number>(-1);

    // フォルダ三点リーダ押下時
    const ChangeDirectoryIndex = (index: number) => {
        setDerectoryIndex(index);
    };

    // 動画三点リーダ押下時
    const ChangeFootageIndex = (index: number) => {
        setFootageIndex(index);
    };

    // フォルダ名前を変更押下時
    const EditFolder = (id: number, name: string) => {
        if (handleEditFolder) {
            handleEditFolder(id, name);
        }
    };

    // フォルダ削除押下時
    const DeleteFolder = (id: number, hasDir: boolean) => {
        if (handleDeleteFolder) {
            handleDeleteFolder(id, hasDir);
        }
    };

    // フッテージクリックでプレビューモーダル表示
    const HandleFootage = (id: number, status: string) => {
        if (handleClickFootage) {
            handleClickFootage(id, status);
        }
    };

    // フッテージ名前の変更押下時
    const EditFootage = (id: number, name: string) => {
        if (handleEditFootage) {
            handleEditFootage(id, name);
        }
    };

    //フッテージ削除ボタン押下時
    const DeleteFootage = (id: number) => {
        if (handleDeleteFootage) {
            handleDeleteFootage(id);
        }
    };

    return (
        <div className={styles.mainDiv} ref={directoryRef}>
            {/* ディレクトリ一覧表示 */}
            {directoryList &&
                directoryList.map((dir, index) => (
                    <div key={dir.id} className={styles.directoryDiv}>
                        <div
                            className={styles.dirNameDiv}
                            onClick={() => clickFolder(dir.id, dir.name)}
                        >
                            <FolderIcon />
                            <PuiTypography>{dir.name}</PuiTypography>
                        </div>
                        {IsDevice("desktop") && (
                            <div
                                onClick={() => ChangeDirectoryIndex(index)}
                                className={styles.icon}
                            >
                                <MoreVert />
                            </div>
                        )}
                        {index === directoryIndex && (
                            <>
                                <div className={styles.directoryEdit}>
                                    <div
                                        onClick={() => {
                                            EditFolder(dir.id, dir.name);
                                            setDerectoryIndex(-1);
                                        }}
                                    >
                                        <PuiTypography>名前を変更</PuiTypography>
                                    </div>
                                    <div
                                        onClick={() => {
                                            DeleteFolder(dir.id, dir.hasDirectory);
                                            setDerectoryIndex(-1);
                                        }}
                                    >
                                        <PuiTypography> 削除</PuiTypography>
                                    </div>
                                </div>
                                <div
                                    className={styles.bg}
                                    onClick={() => ChangeDirectoryIndex(-1)}
                                />
                            </>
                        )}
                    </div>
                ))}

            {/* フッテージ一覧表示 */}
            {footageList &&
                footageList.map((footage, index) => (
                    <div key={footage.id} className={styles.footageDiv}>
                        <div
                            className={styles.footageNameDiv}
                            onClick={() => HandleFootage(footage.id, footage.status)}
                        >
                            <VideoFile />
                            <PuiTypography>{footage.name}</PuiTypography>
                        </div>
                        {IsDevice("desktop") && (
                            <div onClick={() => ChangeFootageIndex(index)} className={styles.icon}>
                                <MoreVert />
                            </div>
                        )}
                        {index === footageIndex && (
                            <>
                                <div className={styles.footageEdit}>
                                    <div
                                        onClick={() => {
                                            EditFootage(footage.id, footage.name);
                                            setFootageIndex(-1);
                                        }}
                                    >
                                        <PuiTypography>名前を変更</PuiTypography>
                                    </div>
                                    <div
                                        onClick={() => {
                                            DeleteFootage(footage.id);
                                            setFootageIndex(-1);
                                        }}
                                    >
                                        <PuiTypography> 削除</PuiTypography>
                                    </div>
                                </div>
                                <div className={styles.bg} onClick={() => ChangeFootageIndex(-1)} />
                            </>
                        )}
                    </div>
                ))}
        </div>
    );
}
export default memo(DirectoryList);
